export default __webpack_public_path__ + "static/media/la-regular-400.aa859c0d.woff";